const notFound = {
  title: 'Page not found',
  description: "The page you're looking for doesn't exist or you don't have access to it.",
  goBack: 'Go back',
  home: 'Home',
};

export default notFound;